/*
 *
 * Package: `@dbh/all-list-page`.
 *
 */const importAllListPage=()=>import('./component-584df5ac.js'/*  webpackChunkName: 'dbh.all-list-page.component' */);const importAllListPageSsr=()=>import('./ssr-cc551ddb.js'/*  webpackChunkName: 'dbh.all-list-page.ssr' */);// Only export dynamic imports from the `index.js` of our `@dbh/*-page` packages,
// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importAllListPage, importAllListPageSsr };
